import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {CashDesk} from '../Model'
import {T} from 'helpers/i18n'
import {toMoney, toPercentage, toDateTime} from 'helpers/Format'
import {Table} from 'components'
import Report from '../components/Report'

interface Props {
  store?: Store
}

@inject('store')
@observer
class CashDesks extends PureComponent<Props, object> {
  componentDidMount() {
    this.props.store!.reports.readCashDesk()
  }

  render() {
    const {reports} = this.props.store!
    const headers = ['state', 'date', 'cashAmount', 'cardAmount']
    const items = reports.cashDesks
    return (
      <Report
        header={headers}
        items={items}
        loading={!reports.cashDesksLoaded}
        keyExtractor={(cashDesk: CashDesk) => String(cashDesk.id)}
        format={(cashDesks: CashDesk[]) =>
          cashDesks.map(cashDesk => ({
            ...cashDesk,
            state: T(cashDesk.state),
            date: toDateTime(cashDesk.date),
            cashAmount: toMoney(cashDesk.cashAmount),
            cardAmount: toMoney(cashDesk.cardAmount)
          }))}
      />
    )
  }
}

export default CashDesks



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/CashDesk.tsx